module.exports = __webpack_public_path__ + "static/media/DataHome.de3f68d7.png";